const DEFAULT_MAX_INITIALS = 2;

/**
 * First letter of each whitespace-separated part, uppercased.
 *
 * `maxInitials` caps the result — avatar circles overflow past two characters, which is why the
 * default is 2. Pass a higher value only when the surface can actually fit it.
 */
export const getInitials = (name?: string, maxInitials: number = DEFAULT_MAX_INITIALS): string =>
	(name ?? '')
		.split(' ')
		.filter(Boolean)
		.slice(0, maxInitials)
		.map(part => part[0].toUpperCase())
		.join('');
